import { render, staticRenderFns } from "./AppGlobalSidebarListAccordionItem.vue?vue&type=template&id=13051fc0&"
import script from "./AppGlobalSidebarListAccordionItem.vue?vue&type=script&lang=js&"
export * from "./AppGlobalSidebarListAccordionItem.vue?vue&type=script&lang=js&"
import style0 from "./AppGlobalSidebarListAccordionItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports